import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { User, Mail, Smartphone, Lock } from 'lucide-react';
import styles from './Auth.module.css';

export default function EntranceRegisterForm() {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  async function onSubmit(event) {
    event.preventDefault();
    setIsLoading(true);

    const formData = new FormData(event.target);
    try {
      const response = await fetch('/api/register', {
        method: 'POST',
        body: JSON.stringify({
          name: formData.get('name'),
          email: formData.get('email'),
          mobileNo: formData.get('mobileNo'),
          password: formData.get('password'),
        }),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      if (response.ok) {
        navigate('/login');
      } else {
        throw new Error('Registration failed');
      }
    } catch (error) {
      console.error('Registration error:', error);
      // Here you would typically show an error message to the user
    } finally {
      setIsLoading(false);
    }
  }



  const handleRoute = ()=>{
    navigate('/EntranceExam/login')
  }
  

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h1 className={styles.title}>Create Account</h1>
        <form onSubmit={onSubmit} className={styles.form}>
          <div className={styles.inputGroup}>
            <User className={styles.icon} size={18} />
            <input id="name" name="name" type="text" required className={styles.input} placeholder="Name" />
          </div>
          <div className={styles.inputGroup}>
            <Mail className={styles.icon} size={18} />
            <input id="email" name="email" type="email" required className={styles.input} placeholder="Email" />
          </div>
          <div className={styles.inputGroup}>
            <Smartphone className={styles.icon} size={18} />
            <input id="mobileNo" name="mobileNo" type="tel" required className={styles.input} placeholder="Mobile Number" />
          </div>
          <div className={styles.inputGroup}>
            <Lock className={styles.icon} size={18} />
            <input id="password" name="password" type="password" required className={styles.input} placeholder="Password" />
          </div>
          <button type="submit" className={styles.button} disabled={isLoading}>
            {isLoading ? 'Creating Account...' : 'Sign Up'}
          </button>
        </form>
        <p className={styles.switchText}>
          Already have an account?{' '}
          <a   
          onClick={handleRoute}
          className={styles.switchLink}>Log In</a>
        </p>
      </div>
    </div>
  );
}
